import { render, staticRenderFns } from "./PendenciesReport.vue?vue&type=template&id=600f1861&scoped=true&"
import script from "./PendenciesReport.vue?vue&type=script&lang=js&"
export * from "./PendenciesReport.vue?vue&type=script&lang=js&"
import style0 from "./PendenciesReport.vue?vue&type=style&index=0&id=600f1861&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "600f1861",
  null
  
)

export default component.exports